export const ALLOCATION_LIST_ROOT_URL = '/work_order_allocation';
export const LATEST_PART_REVISION_URL = `${ALLOCATION_LIST_ROOT_URL}/latestPartRevision`;
export const LATEST_CUSTOMER_REVISION_URL = `${ALLOCATION_LIST_ROOT_URL}/latestCustomerRevision`;
export const VALIDATE_SCANNED_LOT = '/scans/parts';
